import { Filter, SearchInput, useGetIdentity, usePermissions } from "react-admin";
import { TechnicalReportGroupInput, UniversityDepartmentInput, UniversityInput } from "../component/input";
import React from "react";
import { StateInput } from "ra-friendsofbabba";
import { get } from "lodash";
import RepliesSentInput from "./inputs/RepliesSentInput";
import CaseScenarioSelectInput from "./inputs/CaseScenarioSelectInput";

const Filters = (props) => {
  const { loading, permissions } = usePermissions();
  const isAdmin = !loading && permissions && permissions(["admin"]);
  const isTro = !loading && permissions && permissions(["tro"]);
  const isReader = !loading && permissions && permissions(["reader"]);
  const { identity } = useGetIdentity();
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn />
      <StateInput source="state" alwaysOn />
      {(isAdmin || isReader) && <UniversityInput source="university_id" />}
      {(isAdmin || isReader || isTro) && (
        <UniversityDepartmentInput
          source="university_department_id"
          filterValues={{
            ...props.filterValues,
            university_id: isTro ? get(identity, "university_id") : get(props.filterValues, "university_id"),
          }}
          alwaysOn={isTro}
        />
      )}
      <TechnicalReportGroupInput source="technical_report_group_id" />
      {(isAdmin || isReader || isTro) && <CaseScenarioSelectInput source="case_scenario" />}
      {(isAdmin || isReader || isTro) && <RepliesSentInput source="replies_sent" />}
    </Filter>
  );
};
export default Filters;
